import React, { FC, useContext } from 'react';
import { Checkbox } from '@marriott/mi-ui-library-shop';
import CommonUtils from '../../../utils/CommonUtils';
import { ContentContext, FocusContext, FormValuesContext } from '../../index.contexts';
import { USE_POINTS } from '../../../constants/StoreConstants';
import { setSpecialRates, setUsePoints } from '../../../store/store.actions';
import { StyledUsePointsDiv } from './usePoints.styles';

declare module 'react' {
  interface HTMLAttributes<T> {
    custom_click_track_value?: string;
  }
}

export interface UsePointsProps {
  value: string;
}

const UsePoints: FC<UsePointsProps> = () => {
  const { formValues, setFormValues } = useContext(FormValuesContext);
  const { setIsUserInteractWithComp } = useContext(FocusContext);
  const { usePointsCertificates, disableUsePointCertificates } = useContext(ContentContext);
  // const { interactionsSelected, setInteractionsSelected } = useSessionUpdateContext();

  const checkboxValue = formValues?.[USE_POINTS]?.value;
  const clickTrackingLoc = 'Search Form';

  // method to handle check/uncheck of usepoints checkbox
  const handleCheckClick = (event: React.KeyboardEvent<HTMLElement>): void => {
    if (event.key === 'Enter' || event.keyCode === 13) {
      // setInteractionsSelected({ ...interactionsSelected, usePoints: true });
      // when use points is set to some value then special rates will set to default
      setIsUserInteractWithComp(true); //on search page capture user interactions
      setFormValues(
        setSpecialRates({
          displayText: '',
          clusterCode: 'none',
          corporateCode: '',
        })
      );

      setFormValues(
        setUsePoints({
          value: !checkboxValue,
        })
      );
    }
  };
  // method to handle check/uncheck of usepoints checkbox
  const handleCheckChange = (event: React.ChangeEvent<HTMLElement>): void => {
    if (event.type === 'change') {
      // setInteractionsSelected({ ...interactionsSelected, usePoints: true });
      // when use points is set to some value then special rates will set to default
      setIsUserInteractWithComp(true); //on search page capture user interactions
      setFormValues(
        setSpecialRates({
          displayText: '',
          clusterCode: 'none',
          corporateCode: '',
        })
      );

      setFormValues(
        setUsePoints({
          value: !checkboxValue,
        })
      );
    }
  };

  if (disableUsePointCertificates) {
    return null;
  }

  return (
    <StyledUsePointsDiv className="search__use-points t-font-s browser-outline">
      <Checkbox
        inputClassName="custom_click_track"
        checkboxLabel={usePointsCertificates}
        checkboxName="useRewardsPoints"
        checkboxId={CommonUtils.getElementId()}
        checked={checkboxValue}
        onChange={(e): void => handleCheckChange(e)}
        onKeyDown={(e): void => handleCheckClick(e)}
        value={String(checkboxValue)}
        size={18}
        ariaLabelledbyID={`ariaID-${CommonUtils.getElementId()}`}
        custom_click_track_value={`${clickTrackingLoc}| Use Points/Awards checkbox |internal`}
      />
    </StyledUsePointsDiv>
  );
};

export default UsePoints;
